import React from "react";

import { ContextProps } from "./DialogManager.types";

export const DialogManagerContext = React.createContext<ContextProps | null>(
  null,
);
